<template>
  <common-template>
    <template v-slot:body>
      <search-list v-if="isReady && !isNotFound"
        :isReady="isReady"
        :preflistFiltered="prefListFiltered"
        :preflist="prefList"
        :citylistall="cityList"
        :citylist="cityListFiltered"
        :townlist="townListFiltered"
        />
      <search-list-not-found v-if="isNotFound" />
      <search-loading v-if="!isReady && !isNotFound" />
    </template>
  </common-template>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';
import MixinAPI from '@/plugins/mixin-api';
import MixinMeta from '@/plugins/mixin-meta';
import SearchList from '@/components/search/kodate/SearchList';
import SearchListNotFound from '@/components/search/kodate/SearchListNotFound';
import CommonTemplate from '@/components/templates/CommonTemplate';
import SearchLoading from '@/components/search/kodate/SearchLoading';
// import dayjs from 'dayjs';

const canonical = location.href.match(/\/$/) === null ? `${location.href}/` : location.href;

export default {
  name: 'SearchKodate',
  components: {
    SearchList,
    SearchListNotFound,
    CommonTemplate,
    SearchLoading,
  },
  data() {
    return {
      isReady: false,
      isNotFound: false,
      noProps: false,
      sugguestProps: [],
      preflist: [],
      citylist: [],
      townlist: [],
      prefListFiltered: [],
      cityListFiltered: [],
      townListFiltered: [],
      prefcode: '',
      citycode: '',
      towncode: '',
      fav: [],
      // banner1Flag: true,
      // banner2Flag: true
    };
  },
  metaInfo() {
    return {
      link: [
        { rel: 'canonical', href: canonical },
      ],
    };
  },
  async created() {
    this.prefcode = this.$route.params.prefecture;
    this.citycode = this.$route.params.city;
    this.towncode = this.$route.params.town;

    let codeType;
    if (this.towncode) {
      codeType = 2;
    } else if (this.citycode) {
      codeType = 1;
    } else if (this.prefcode) {
      codeType = 0;
    }

    this.type = codeType;

    this.prefList = await this.getPrefectureList();
    this.prefListFiltered = await this.getPrefectureList(1, this.$route.meta.kind);
    this.cityList = await this.getCityList(0, this.prefcode, 0);
    this.cityListFiltered = await this.getCityList(1, this.prefcode, this.$route.meta.kind);
    if (this.citycode) {
      this.townList = await this.getTownList(0, this.citycode);
      this.townListFiltered = await this.getTownList(1, this.citycode, this.$route.meta.kind);
    }


    // pref,city code 排他処理
    // 存在しない都道府県排除
    if (this.prefList.filter(n => +n.pref_code === +this.prefcode).length < 1) {
      location.href = '/';
    }
    // 存在しない市区町村排除
    if (this.citycode && this.cityList.filter(n => +n.city_code === +this.citycode).length < 1) {
      location.href = '/';
    }
    //  存在しない町域排除
    if (this.towncode && this.townList.filter(n => +n.town_code === +this.towncode).length < 1) {
      location.href = '/';
    }

    // 物件が0件の場合
    // 物件が0件の都道府県処理
    if (this.prefListFiltered.filter(n => +n.pref_code === +this.prefcode).length < 1) {
      this.isNotFound = true;
    }
    // 物件が0件の市区町村処理
    if (this.citycode && this.cityListFiltered.filter(n => +n.city_code === +this.citycode).length < 1) {
      this.isNotFound = true;
    }
    // 物件が0件の市区町村処理
    if (this.towncode && this.townListFiltered.filter(n => +n.town_code === +this.towncode).length < 1) {
      this.isNotFound = true;
    }
    const values = {};
    let locationObject;
    // LocaleObject生成
    values.pref = this.prefList.filter(n => +n.pref_code === +this.prefcode)[0];
    this.metaSetForList(values.pref.pref_name, this.$route.meta.kind);
    if (this.type !== 0) {
      values.city = this.cityList.filter(n => n.city_code.toString() === this.citycode.toString())[0];
      this.metaSetForList(values.city.city_name, this.$route.meta.kind);
    }
    if (this.type === 2) {
      values.town = this.townListFiltered.filter(n => n.town_code.toString() === this.towncode.toString())[0];
      this.metaSetForList(values.town.town_name, this.$route.meta.kind);
    }
    if (values !== undefined) {
      if (this.type === 0) {
        locationObject = {
          type: 0,
          area: {
            id: values.pref.area_id,
            code: values.pref.area_code,
            name: values.pref.area_name,
          },
          pref: {
            id: values.pref.pref_id,
            code: values.pref.pref_code,
            name: values.pref.pref_name,
          },
          city: {
            id: null,
            code: null,
            name: null,
          },
          town: {
            id: null,
            code: null,
            name: null,
          },
          station: {
            id: null,
            code: null,
            name: null,
          },
        };
      } else if (this.type === 1) {
        locationObject = {
          type: 1,
          area: {
            id: values.pref.area_id,
            code: values.pref.area_code,
            name: values.pref.area_name,
          },
          pref: {
            id: values.pref.pref_id,
            code: values.pref.pref_code,
            name: values.pref.pref_name,
          },
          city: {
            id: values.city_id,
            code: values.city.city_code,
            name: values.city.city_name,
          },
          town: {
            id: null,
            code: null,
            name: null,
          },
          station: {
            id: null,
            code: null,
            name: null,
          },
        };
      } else if (this.type === 2) {
        locationObject = {
          type: 2,
          area: {
            id: values.pref.area_id,
            code: values.pref.area_code,
            name: values.pref.area_name,
          },
          pref: {
            id: values.pref.pref_id,
            code: values.pref.pref_code,
            name: values.pref.pref_name,
          },
          city: {
            id: values.city.city_id,
            code: values.city.city_code,
            name: values.city.city_name,
          },
          town: {
            id: values.town.town_id,
            code: values.town.town_code,
            name: values.town.town_name,
          },
          station: {
            id: null,
            code: null,
            name: null,
          },
        };
      }
      this.$store.commit('setLocation', locationObject);

      // お気に入りリスト
      this.fav = [];
      this.fav = JSON.parse(localStorage.getItem('fav'));
      // this.$store.commit('setFavorite', this.fav);

      // noindex処理
      if (this.type >= 1 && this.$route.meta.kind === 0) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', 'robots');
        meta.setAttribute('content', 'noindex');
        document.getElementsByTagName('head')[0].appendChild(meta);
      }

      this.isReady = true;
    } else {
      location.href = '/';
    }

    // this.bannerLocalStorage();
  },
  methods: {
    // bannerLocalStorage() {
    //   const getBanner1 = JSON.parse(localStorage.getItem('displayBanner1'));
    //   const getBanner2 = JSON.parse(localStorage.getItem('displayBanner2'));
    //   const dd = new Date();
    //   const getDate = dayjs(dd).format('YYYYMMDD');
    //   const setDisplay = {
    //     date: getDate,
    //     count: 1
    //   };

    //   if (getBanner1) {
    //     if (getBanner1.date === getDate) {
    //       getBanner1.count += 1;
    //       localStorage.setItem('displayBanner1', JSON.stringify(getBanner1));
    //     }
    //   } else {
    //     localStorage.setItem('displayBanner1', JSON.stringify(setDisplay));
    //   }

    //   if (getBanner2) {
    //     if (getBanner2.date === getDate) {
    //       getBanner2.count += 1;
    //       localStorage.setItem('displayBanner2', JSON.stringify(getBanner2));
    //     }
    //   } else {
    //     localStorage.setItem('displayBanner2', JSON.stringify(setDisplay));
    //   }

    //   if (getBanner1.count >= 2) {
    //     this.banner1Flag = false;
    //   }
    //   if (getBanner2.count >= 2) {
    //     this.banner2Flag = false;
    //   }
    // }
  },
  mixins: [IsMobileMixin, MixinAPI, MixinMeta],
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
